let getters = {
  statement (state) {
    return state.statement
  },
  statementCategories (state) {
    return state.statementCategories
  },
  filteredStatement (state) {
    return state.filteredStatement
  },
  recentTransactions (state) {
    return state.recentTransactions
  },
  totalTransactionCount (state) {
    return state.totalTransactionCount
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/statement/getters.js